<template>
  <SlideOver :open="on" @close="close">
    <div class="w-screen max-w-md h-full">
      <form
        @submit.prevent="updateChemicalService"
        class="h-full divide-y divide-gray-200 flex flex-col bg-white shadow-xl"
      >
        <div class="flex-1 h-0 overflow-y-auto">
          <div class="py-6 px-4 bg-light-blue-700 sm:px-6">
            <div class="flex items-center justify-between">
              <h2
                id="slide-over-heading"
                class="text-lg font-medium text-white"
              >
                {{ chemicalService.data.name }}
              </h2>
              <div class="ml-3 h-7 flex items-center">
                <button
                  type="button"
                  @click="close()"
                  class="
                    bg-light-blue-700
                    rounded-md
                    focus:outline-none focus:ring-2 focus:ring-white
                  "
                >
                  <XIcon class="h-6 w-6 hover:text-white text-light-blue-200" />
                </button>
              </div>
            </div>
            <div class="mt-1">
              <p class="text-sm text-light-blue-300">
                {{ t("description") }}
              </p>
            </div>
          </div>
          <div class="flex-1 flex flex-col justify-between">
            <div class="px-4 divide-y divide-gray-200 sm:px-6">
              <div class="space-y-6 pt-6 pb-5">
                <ui-input
                  ref="name"
                  :invalid="'name' in form.errors"
                  :error="form.errors.name"
                  type="text"
                  :label="t('name')"
                  v-model="form.name"
                ></ui-input>

                <ui-input
                  :invalid="'price' in form.errors"
                  :error="form.errors.price"
                  type="number"
                  step="any"
                  :label="t('price')"
                  v-model.number="form.price"
                ></ui-input>

                <ui-input
                  :invalid="'rule' in form.errors"
                  :error="form.errors.rule"
                  type="text"
                  :label="t('rule')"
                  v-model="form.rule"
                ></ui-input>

                <ui-textarea
                  rows="5"
                  :invalid="'description' in form.errors"
                  :error="form.errors.description"
                  :help="t('description_help')"
                  :label="t('description')"
                  v-model="form.description"
                ></ui-textarea>

                <ui-textarea
                  rows="5"
                  :invalid="'quotation_objective' in form.errors"
                  :error="form.errors.quotation_objective"
                  :label="t('quotation_objective')"
                  v-model="form.quotation_objective"
                  :cornerHint="t('optional')"
                ></ui-textarea>

                <ui-textarea
                  rows="5"
                  :invalid="'quotation_methodology' in form.errors"
                  :error="form.errors.quotation_methodology"
                  :label="t('quotation_methodology')"
                  v-model="form.quotation_methodology"
                  :cornerHint="t('optional')"
                ></ui-textarea>

                <ui-textarea
                  rows="5"
                  :invalid="'quotation_equipment' in form.errors"
                  :error="form.errors.quotation_equipment"
                  :label="t('quotation_equipment')"
                  v-model="form.quotation_equipment"
                  :cornerHint="t('optional')"
                ></ui-textarea>
              </div>

              <div
                class="
                  pt-4
                  mb-6
                  flex flex-col
                  justify-stretch
                  space-y-3
                  sm:flex-row sm:space-y-0 sm:space-x-4
                "
              >
                <ui-button
                  focusColorStyling="focus:ring-red-500"
                  backgroundStyling="bg-white hover:bg-red-50"
                  borderStyling="border border-red-300"
                  textColorStyling="text-red-700 hover:text-red-500"
                  type="button"
                  class="flex justify-center w-full"
                  @click="confirmingChemicalServiceDeletion = true"
                >
                  <TrashIcon class="-ml-1 mr-2 h-5 w-5 text-red-400" />

                  {{ t("delete_chemical_service") }}</ui-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="flex-shrink-0 px-4 py-4 flex justify-end">
          <ui-button
            backgroundStyling="bg-white"
            borderStyling="border border-gray-300"
            textColorStyling="text-gray-700 hover:text-gray-500"
            type="button"
            @click="close"
            >{{ t("cancel") }}</ui-button
          >

          <ui-button type="submit" class="ml-4">
            {{ t("save") }}
          </ui-button>
        </div>
      </form>
    </div>
  </SlideOver>
  <ui-modal
    :show="confirmingChemicalServiceDeletion"
    @close="confirmingChemicalServiceDeletion = false"
  >
    <div class="sm:flex sm:items-start">
      <div
        class="
          mx-auto
          flex-shrink-0 flex
          items-center
          justify-center
          h-12
          w-12
          rounded-full
          bg-red-100
          sm:mx-0 sm:h-10 sm:w-10
        "
      >
        <ExclamationIcon class="h-6 w-6 text-red-600" />
      </div>
      <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          {{ t("confirm_chemical_service_deletion_title") }}
        </h3>
        <div class="mt-2">
          <p class="text-sm text-gray-500">
            {{ t("confirm_chemical_service_deletion_text") }}
          </p>
        </div>
      </div>
    </div>
    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
      <ui-button
        backgroundStyling="bg-red-600 hover:bg-red-700"
        focusColorStyling="focus:ring-red-500"
        type="button"
        @click="deleteChemicalService"
        class="flex justify-center w-full sm:w-auto ml-0 sm:ml-3"
        >{{ t("delete_chemical_service") }}</ui-button
      >
      <ui-button
        backgroundStyling="bg-white"
        borderStyling="border border-gray-300"
        textColorStyling="text-gray-700 hover:text-gray-500"
        type="button"
        @click="confirmingChemicalServiceDeletion = false"
        class="flex justify-center w-full sm:w-auto mt-3 sm:mt-0"
        >{{ t("nevermind") }}</ui-button
      >
    </div>
  </ui-modal>
</template>

<script>
import { useI18n } from "vue-i18n";
import { XIcon, ExclamationIcon } from "@heroicons/vue/outline";
import { TrashIcon } from "@heroicons/vue/solid";
import SlideOver from "@/Shared/SlideOver";

export default {
  emits: ["toggleVisibility"],

  components: {
    XIcon,
    ExclamationIcon,
    TrashIcon,
    SlideOver,
  },

  props: {
    on: { type: Boolean, required: true },

    chemicalService: { type: Object, required: true },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  mounted() {
    if (this.on) {
      setTimeout(() => {
        this.$refs.name.$refs.input.focus();
      }, 250);
    }
  },

  data() {
    return {
      confirmingChemicalServiceDeletion: false,
      form: this.$inertia.form(
        {
          _method: "PUT",
          name: this.chemicalService.data.name,
          price: this.chemicalService.data.price / 100,
          rule: this.chemicalService.data.rule,
          description: this.chemicalService.data.description,
          quotation_objective: this.chemicalService.data.quotation_objective,
          quotation_methodology:
            this.chemicalService.data.quotation_methodology,
          quotation_equipment: this.chemicalService.data.quotation_equipment,
        },
        { key: "updateChemicalService" }
      ),
    };
  },

  methods: {
    updateChemicalService() {
      this.form.put(
        this.route("chemical-services.update", {
          chemical_service: this.chemicalService.data.id,
          search: this.$page.props.filters.search,
        }),
        {
          preserveScroll: true,
        }
      );
    },

    close() {
      this.form.clearErrors();
      this.form.reset();
      this.$emit("toggleVisibility");
    },

    deleteChemicalService() {
      this.form.delete(
        this.route("chemical-services.destroy", {
          chemical_service: this.chemicalService.data.id,
          search: this.$page.props.filters.search,
        }),
        {
          preserveScroll: true,
          onSuccess: (page) => {
            this.confirmingChemicalServiceDeletion = false;
          },
        }
      );
    },
  },

  watch: {
    on: {
      handler: (on) => {
        if (on) {
          setTimeout(() => {
            this.$refs.name.$refs.input.focus();
          }, 250);
        }
      },
    },

    chemicalService: {
      handler: (chemicalService, oldChemicalService) => {
        if (chemicalService.id != oldChemicalService.id) {
          this.form.clearErrors();
          this.form.name = this.chemicalService.data.name;
          this.form.rule = this.chemicalService.data.rule;
          this.form.description = this.chemicalService.data.description;
          this.form.price = this.chemicalService.data.price;
          this.form.quotation_objective =
            this.chemicalService.data.quotation_objective;
          this.form.quotation_methodology =
            this.chemicalService.data.quotation_methodology;
          this.form.quotation_equipment =
            this.chemicalService.data.quotation_equipment;
        }
      },
    },
  },
};
</script>

<i18n>
{
  "es": {
    "description": "Ver y editar la información del servicio",
    "name": "Nombre del servicio",
    "price": "Precio del servicio",
    "rule": "Norma",
    "description": "Descripción",
    "description_help": "Esta descripción se usa para generar las cotizaciones",
    "quotation_objective": "Objetivo",
    "quotation_methodology": "Metodología",
    "quotation_equipment": "Equipo",
    "save": "Guardar",
    "optional": "opcional",
    "cancel": "Cancelar",
    "delete_chemical_service": "Eliminar servicio",
    "confirm_chemical_service_deletion_title": "¿Seguro que deseas eleminar?",
    "confirm_chemical_service_deletion_text": "Al eliminar el servicio, todos los recursos relacionados con el servicio permanecerán activos, sin embargo no podrán ser relacionados nuevos recursos.",
    "nevermind": "Mejor no"
  }
}
</i18n>

